import React from 'react';


const RefundPage = () => {
    return (
        <div className="privacy-page">
            <div className="container">
                <h1>Refund Policy</h1>
                <h3>
                    <strong>
                        ZenZzz Lifetime Money-Back Guarantee
                    </strong>
                </h3>
                <p>At ZenZzz, we truly appreciate your business and stand behind our product. Your satisfaction is our priority, and we’re confident that ZenZzz will help you optimize your sleep. That’s why we offer a <strong>Lifetime Money-Back Guarantee</strong> so you can try Zenzzz risk-free.</p>
                <hr></hr>
                <p><strong>Policy Details:</strong></p>
                <p>We offer a 30-day Money-Back Guarantee for the first purchase of our products, applicable after at least two weeks of use from the time of shipment. Please review the exceptions below. A full refund for the product will be issued to the original payment method used, minus shipping charges (and any applicable shipping taxes) per the policy outlined below.</p>
                <p>Please contact <strong><a href="mailto:support@zenzzz.online">support@zenzzz.online</a></strong> to initiate your request. Include your Order Number and specify the products you wish to return.</p>
                <hr></hr>
                <p><strong>Exchanges</strong></p>
                <p>We do not offer exchanges.</p>
                <hr></hr>
                <p><strong>Exceptions</strong></p>
                <ul>
                    <li>Refunds are available for first-time purchases only.</li>
                    <li>Discounted or discontinued items are not eligible for returns or refunds.</li>
                    <li>Products purchased with Rewards points are not eligible for return or refund.</li>
                    <li>Refund requests must be submitted through our customer support team with proof of purchase.</li>
                    <li>Purchases made with a gift card are non-refundable.</li>
                    <li>All supplements, personal care, and food items are non-returnable.</li>
                    <li>Customers requesting a refund <strong>beyond 30 days from the delivery date</strong> may be subject to additional processing fees.</li>
                    <li>All return inquiries should be directed to <strong><a href="mailto:support@zenzzz.online">support@zenzzz.online</a></strong> .</li>
                </ul>
                <hr></hr>
                <p><strong>Additional Information:</strong></p>
                <p>Refunds are issued only to the original payment method. If the original payment method is no longer available, the refund will be forfeited. Refunds typically take 5-7 business days to appear, but processing times may vary depending on your bank or credit card company.</p>
                <p>We cannot process refunds to prepaid debit cards.</p>
                <p>Orders paid by cashier’s check or money order will receive a refund check via mail, sent to the original billing name and address. No exceptions will be made to prevent fraud.</p>

            </div>
        </div>
    );
};

export default RefundPage;